<template>
    <!-- <AdminLayout> -->
    <section class="flex items-start">
        <div class="w-full">
            <div class="mt-12">
                <div class="border rounded-lg py-7 px-8">
                    <div class="flex justify-between mb-5">
                        <p class="font-semibold text-xl text-neutral-800">Leave Status</p>
                    </div>

                    <div class="flex mb-8 items-center bg-neutral-300/50 rounded-md p-1">
                        <div class="ml-auto" v-if="userType === 'admin'">
                            <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                            <select class="border border-white text-sm rounded-full py-1 px-2" v-model="slectedLocation"
                                @change="fetchLeaveRequests">
                                <option value="">Location</option>
                                <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name
                                    }}</option>
                            </select>
                        </div>
                        <div class="w-96 mx-3">
                            <input type="search" v-model="searchQuery" name="" id=""
                                class="w-full rounded-full bg-white text-sm px-6 py-3 outline-none block font-normal"
                                placeholder="Search...">
                        </div>
                        <!-- <div>
                                <button class="btn-primary">
                                    Download
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        class="ml-2">
                                        <path fill="currentColor"
                                            d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z" />
                                    </svg>
                                </button>
                            </div> -->
                    </div>
                    <div class="mb-2">
                        <p class="font-medium text-sm text-black ">Number of leaves Pending : <span
                                class="text-neutral-700 font-normal">{{ pendingCount }}</span> </p>
                    </div>
                    <div class="overflow-x-auto">
                        <div class="min-w-[1695px]">
                            <div class="grid grid-cols-12 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center">
                                    No.
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">
                                    Employee Name
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Employee
                                    ID
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Leave Type
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Leave
                                    Duration
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Leave
                                    Applied On
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Date</div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">
                                    Position</div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center">
                                    Status
                                </div>
                                <div
                                    class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center col-span-2">
                                    Actions
                                </div>
                            </div>

                                <div v-if="isLoading" class="min-w-[1695px]">
                                    <!-- Skeleton Loader - Matches 12-column grid -->
                                    <div class="grid grid-cols-12 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 3" :key="index">
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2" v-for="index in 7" :key="index">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="paginatedData.length === 0" class="text-center py-6 text-neutral-500 text-sm">
                                    No data found.
                                    </div>

                                    <div v-for="(item, index) in paginatedData" :key="item.id">
                                        <div
                                            class="grid grid-cols-12 bg-white divide-x divide-y divide-[#eaeaea]">
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center border-t border-[#eaeaea]">
                                                {{startIndex + index + 1 }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-2">
                                                {{ item.user.fname }} {{ item.user.lname }}
                                            </div>
                                            <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                                {{ item.user.empid }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ item.leave_name }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ item.total_days }} Days
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ formatDate(item.applied_date) }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ formatDate(item.start_date) }} to {{ formatDate(item.end_date) }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ item.user.designation }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                {{ item.status }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center col-span-2 space-x-2">
                                                <a href="#"
                                                    class="inline-flex items-center justify-center bg-green-400 rounded-md px-3 py-2 text-white text-xs font-normal"
                                                    :class="isCancelDisabled(item) || loadingApproveId === item.id ? 'disabled cursor-not-allowed' : ''"
                                                    @click="approveLeave(item.id)"><template
                                                        v-if="loadingApproveId === item.id">
                                                        <svg class="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                                                            <circle cx="12" cy="12" r="10" stroke="white" stroke-width="4"
                                                                fill="none"></circle>
                                                        </svg>
                                                        Approve </template>
                                                    <template v-else>
                                                        Approve
                                                    </template></a>
                                                <a href="#"
                                                    class="inline-flex items-center justify-center bg-red-400 rounded-md px-3 py-2 text-white text-xs font-normal"
                                                    :class="isCancelDis(item) || loadingRejectId === item.id ? 'disabled cursor-not-allowed' : ''"
                                                    @click="cancelLeave(item.id)"> <template
                                                        v-if="loadingRejectId === item.id">
                                                        <svg class="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                                                            <circle cx="12" cy="12" r="10" stroke="white" stroke-width="4"
                                                                fill="none"></circle>
                                                        </svg>
                                                        Reject </template>
                                                    <template v-else>
                                                        Reject
                                                    </template></a>
                                                <a href="#" @click.prevent="openPopup(item)"
                                                    class="inline-flex items-center justify-center bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal">View
                                                    Record</a>
                                            </div>
                                        </div>
                                    </div>
                                    <PaginationComponent :totalItems="total" :itemsPerPage="itemsPerPage"
                                v-model:currentPage="currentPage" />
                                </div>

                        </div>
                    </div>



                </div>
            </div>
        </div>
        <!-- <RightSideBar /> -->
    </section>
    <!-- Popup Modal -->
    <div v-if="isPopupOpen" class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 pt-4 px-2">
        <div class="max-w-2xl w-full bg-white mx-auto rounded-lg px-3 pt-3">
            <div class="bg-blue-400 py-3 relative rounded-t-lg">
                <h3 class="text-center text-xl font-semibold text-white capitalize">employee leave application
                    details</h3>
                <button @click="closePopup"
                    class="absolute top-3 right-3 rounded-full bg-white w-7 h-7 flex items-center justify-center text-blue-400">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16">
                        <path fill="currentColor"
                            d="M7.293 8L3.146 3.854a.5.5 0 1 1 .708-.708L8 7.293l4.146-4.147a.5.5 0 0 1 .708.708L8.707 8l4.147 4.146a.5.5 0 0 1-.708.708L8 8.707l-4.146 4.147a.5.5 0 0 1-.708-.708z" />
                    </svg>
                </button>
            </div>
            <div class="py-4 space-y-3">
                <div>
                    <ul class="block">
                        <li class="flex items-center space-x-3 py-3 border-b border-neutral-200">
                            <div class="w-5 h-5">
                                <img src="../../assets/man.png" class="w-full h-full" alt="" srcset="">
                            </div>
                            <p class="text-base text-black font-medium">Employee :</p> <span> {{
                                selectedLeave.user.fname }}
                                {{ selectedLeave.user.lname }}</span>
                        </li>
                        <li class="flex items-center space-x-3 py-3 border-b border-neutral-200">
                            <div class="w-5 h-5">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                                    <path fill="#cfd8dc" d="M5 38V14h38v24c0 2.2-1.8 4-4 4H9c-2.2 0-4-1.8-4-4" />
                                    <path fill="#f44336" d="M43 10v6H5v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4" />
                                    <g fill="#3a1cb7">
                                        <circle cx="33" cy="10" r="3" />
                                        <circle cx="15" cy="10" r="3" />
                                    </g>
                                    <path fill="#b0bec5"
                                        d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2M15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2" />
                                    <path fill="#1cefff"
                                        d="M13 20h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4z" />
                                </svg>
                            </div>
                            <p class="text-base text-black font-medium">Dates :</p>
                            <div class="border border-neutral-200 rounded-md px-2 py-1 text-sm">
                                {{ formatDate(selectedLeave.start_date) }} to {{ formatDate(selectedLeave.end_date) }}
                            </div>
                        </li>
                        <li class="flex items-center space-x-3 py-3 border-b border-neutral-200">
                            <div class="w-5 h-5">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                    <g fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M15.027 7.232a1 1 0 0 1 1.408.128l2.083 2.5a1 1 0 0 1-1.536 1.28l-2.083-2.5a1 1 0 0 1 .128-1.408"
                                            clip-rule="evenodd" />
                                        <path fill-rule="evenodd"
                                            d="M15.027 13.768a1 1 0 0 1-.129-1.408l2.084-2.5a1 1 0 1 1 1.536 1.28l-2.083 2.5a1 1 0 0 1-1.408.128"
                                            clip-rule="evenodd" />
                                        <path fill-rule="evenodd"
                                            d="M17.5 10.5a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h6.5a1 1 0 0 1 1 1M3 3.5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 14a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1"
                                            clip-rule="evenodd" />
                                        <path fill-rule="evenodd"
                                            d="M13 2.5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m0 10a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m-9-10a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0v-14a1 1 0 0 1 1-1"
                                            clip-rule="evenodd" />
                                        <path d="M1.293 2.707a1 1 0 0 1 1.414-1.414l16 16a1 1 0 0 1-1.414 1.414z" />
                                    </g>
                                </svg>
                            </div>
                            <p class="text-base text-black font-medium">Leave Type :</p> <span>{{
                                selectedLeave.leave_name
                            }}</span>
                            <div class="border border-neutral-200 rounded-md px-2 py-1 text-sm">{{
                                selectedLeave.total_days
                            }}</div>
                        </li>
                        <li class="flex items-center space-x-3 py-3 border-b border-neutral-200">
                            <div class="text-sm">
                                {{ selectedLeave.reason }}
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="grid grid-cols-1 gap-1 pt-5">
                    <p v-if="selectedLeave.document" class="text-base text-black font-medium">Document :</p>
                    <button v-if="selectedLeave.document" @click="downloadDocument(selectedLeave.document)"
                        class="font-xl text-white font-semibold px-6 py-2 rounded-lg bg-blue-400 border border-blue-400">
                        View
                    </button>
                </div>

            </div>
        </div>
    </div>
    <!-- </AdminLayout> -->
</template>

<script>
import axios from 'axios';
// import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import PaginationComponent from "../../components/PaginationComponent.vue";
import { BASE_URL, BASE_URL_POP } from "../../config";
import { createToast } from 'mosha-vue-toastify';
import { createLocal } from 'the-storages';
import debounce from 'lodash/debounce'; // ← Add this at the top
const mirror = createLocal();
const storage = mirror._prx;
import moment from 'moment';

export default {
    name: 'LeaveListing',

    components: {
        // AdminLayout,
        // RightSideBar,
        PaginationComponent
    },
    data() {
        return {
            data: [],
            itemsPerPage: 10,
            currentPage: 1,
            isPopupOpen: false,
            selectedLeave: {},
            total: 0, // Declare total items
            loadingApproveId: null,
            loadingRejectId: null,
            storage: storage,
            branchList: [],
            slectedLocation: '',
            userType: '',
            isLoading: true,
            searchQuery: null, // ← ADD THIS
            previousLocation: '', // Add this to track location changes
            globalDateFormat: '',
        };
    },
    computed: {
        paginatedData() {
            //const start = (this.currentPage - 1) * this.itemsPerPage;
            //return this.data.slice(start, start + this.itemsPerPage);
            return this.data;
        },
        startIndex() {
            return (this.currentPage - 1) * this.itemsPerPage;
        }
    },
    watch: {
        searchQuery() {
            this.onSearch();
        },
        currentPage(newPage) {
            this.$router.push({ query: { ...this.$route.query, page: newPage } }); // ← add this
            this.fetchLeaveRequests();
        }
    },
    methods: {
        async fetchLeaveRequests() {
            this.isLoading = true;
            try {
                // Only reset page if location changed (not just when it has a value)
                if (this.slectedLocation !== this.previousLocation) {
                    this.currentPage = 1;
                    this.previousLocation = this.slectedLocation;
                }
                const response = await axios.post(
                    `${BASE_URL}/employee-leave-requests?limit=${this.itemsPerPage}&page=${this.currentPage}`,
                    {
                        companyId: localStorage.getItem('company_id'),
                        name: this.searchQuery, // ← Send search query
                        location: this.slectedLocation,
                    }
                );
                this.data = response.data.leaveRequests.data; // Corrected
                this.total = response.data.leaveRequests.total; // Corrected
                // If you need the pending count
                this.pendingCount = response.data.pendingCount;
            } catch (error) {
                console.error("Error fetching leave requests:", error);
            } finally {
                this.isLoading = false;
            }
        },

        openPopup(leave) {
            this.selectedLeave = leave;
            this.isPopupOpen = true;
        },
        closePopup() {
            this.isPopupOpen = false;
        },
        downloadDocument(documentPath) {
            // Define your website base URL
            const baseUrl = `${BASE_URL_POP}`;

            // Construct the full URL
            const documentUrl = baseUrl + documentPath;

            window.open(documentUrl, '_blank');
            // Extract filename from URL
            // const fileName = documentUrl.split('/').pop();

            // const link = document.createElement('a');
            // link.href = documentUrl; // Assuming this is a direct file URL
            // link.download = fileName || 'leave_document.pdf'; // Fallback to default name
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        },
        //         async downloadDocument(documentPath) {
        //     try {
        //         const baseUrl = `${BASE_URL_POP}`;
        //         const url = baseUrl + documentPath;

        //         console.log('Downloading from:', url);

        //         const response = await fetch(url);

        //         if (!response.ok) {
        //             throw new Error(`HTTP error! Status: ${response.status}`);
        //         }

        //         const blob = await response.blob();

        //         const filename = url.split('/').pop() || 'document';
        //         const blobUrl = window.URL.createObjectURL(blob);

        //         const link = document.createElement('a');
        //         link.href = blobUrl;
        //         link.setAttribute('download', filename);
        //         document.body.appendChild(link);
        //         link.click();
        //         document.body.removeChild(link);

        //         window.URL.revokeObjectURL(blobUrl);
        //     } catch (error) {
        //         console.error('Error downloading document:', error);
        //         this.tostMessage('danger', 'Failed to download document.');
        //     }
        // }
        // ,

        isCancelDisabled(item) {
            return (
                item.status === 'Approved' ||
                item.status === 'Canceled'
            );
        },
        isCancelDis(item) {
            return (
                //item.status === 'Pending' ||
                item.status === 'Canceled'
            );
        },
        tostMessage(status, message) {
            createToast({
                // title: title,
                description: message
            },
                {
                    type: status,
                    timeout: 2500,
                    position: 'bottom-right',
                    showIcon: 'true'
                })
        },
        async approveLeave(id) {
            this.loadingApproveId = id;
            try {
                const res = await axios.post(
                    `${BASE_URL}/leave/approve/${id}`,
                    {},
                    {}
                );
                this.tostMessage('success', res.data.message);
                await this.fetchLeaveRequests();
            } catch (err) {
                console.error(err);
                //this.tostMessage('danger',err.response?.data?.message);
                if (err.response?.data?.message) {
                    this.tostMessage('danger', err.response.data.message);
                } else {
                    this.tostMessage('danger', err.response.data.error);
                }
            } finally {
                this.loadingApproveId = null;
            }
        },
        async cancelLeave(id) {
            this.loadingRejectId = id;
            try {
                const res = await axios.post(
                    `${BASE_URL}/leave/cancel/${id}`,
                    {},
                    {}
                );
                this.tostMessage('success', res.data.message);
                await this.fetchLeaveRequests();
            } catch (err) {
                console.error(err);
                //this.tostMessage('danger',err.response?.data?.message);
                if (err.response?.data?.message) {
                    this.tostMessage('danger', err.response.data.message);
                } else {
                    this.tostMessage('danger', err.response.data.error);
                }
            } finally {
                this.loadingRejectId = null;
            }
        },
        async getBranchList() {
            const formData = {
                "company_id": this.storage.companyDetails.id
            };
            await axios.post(BASE_URL + '/get-emp-branch-list', formData)
                .then((response) => {
                    this.branchList = response.data.branchDetails;
                    console.log("Role LIST:: ", response.data);
                })
        },

        formatDate(date) {
            if (!date) return '';
            return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
        },
    },
    mounted() {
        this.fetchLeaveRequests(); // Fetch data when component mounts
    },
    onSearch() {
        this.currentPage = 1; // Reset to first page when searching
        this.fetchLeaveRequests();
    },
    created() {
        const page = parseInt(this.$route.query.page) || 1;
        this.currentPage = page;
        if (this.storage.userType === 'Super Admin') {
            this.slectedLocation = ''; // Set to an empty string or a default value
            this.userType = 'admin';
        } else {
            this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
            this.userType = 'not-admin';
            console.log('branch', this.slectedLocation);
        }
        this.globalDateFormat = localStorage.getItem("globalDateFormat");
        this.getBranchList();

        this.onSearch = debounce(() => {
            this.currentPage = 1;
            this.fetchLeaveRequests();
        }, 400);
    },
};
</script>
<style>
a.disabled {
    color: #cfcfcf;
    background: #f3f3f3;
    pointer-events: none;
    cursor: auto;
}

.loader-spinner {
    border: 2px solid #fff;
    border-top: 2px solid #00000020;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    animation: spin 0.8s linear infinite;
    display: inline-block;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
